import React, { createRef, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Dropdown, Modal, Tab, Tabs } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import { capitalize, isEmpty } from "lodash";
import mixpanel from "mixpanel-browser";
import Swal from "sweetalert2";
import LoadingScreen from "../../../../components/custom/LoadingScreen";
import { brand } from "../../../../config/brands";
import ProfileTab from "../../../../components/providers/ProfileTab";
import ContactTab from "../../../../components/providers/ContactTab";
import ClassesTab from "../../../../components/providers/ClassesTab";
import HomeTab from "../../../../components/providers/HomeTab";
import { bookAnAppointmentText } from "../../../../constants";
import HelmetTag from "../../../../components/helmet/Helmet";
import axios from "../../../../util/axiosInst";
import {
  formatPhoneNumber,
  getName,
  getProviderName,
} from "../../../../util/utils";
import Layout from "../layout/Layout";
import Image from "../custom/Image";
export const MySwal = withReactContent(Swal);

// Helper function to convert name to title case with trim
const formatNameToTitleCase = (name1, name2 = "") => {
  const fullName = `${name1 || ""} ${name2 || ""}`.trim();
  return fullName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Helper function to format user type by removing underscores and adding spaces
const formatUserType = (userType) => {
  if (!userType) return "";
  return userType.replace(/_/g, " ");
};

const ProviderDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [moreMenu, setMoreMenu] = useState("");

  const [condition, setCondition] = useState({
    name: "",
    usertype: "",
    address: "",
  });
  const ref = createRef();

  const [membershipDetail, setMembershipDetail] = useState({});
  const [providerDetail, setProviderDetail] = useState({});
  const [loader, setLoader] = useState(false);
  const [tabKey, settabKey] = useState("");
  const [showBook, setShowBook] = useState(false);
  const [schedulerConfigData, setSchedulerConfigData] = useState({});

  const setSchedulerConfig = (data) => {
    setSchedulerConfigData({
      name: formatNameToTitleCase(data?.firstName, data?.lastName),
      jobTitle: formatNameToTitleCase(formatUserType(data?.userType)),
      lastName: formatNameToTitleCase(data?.lastName),
      firstName: formatNameToTitleCase(data?.firstName),
      medicalClinic: formatNameToTitleCase(data?.clinic[0]?.name),
      npiId: data?.npiId || null,
    });
    const queryParams = new URLSearchParams(location.search);
    const isRecommended = queryParams.get("recommended") === "true";
    const exploreProviderClicked = sessionStorage.getItem(
      "exploreProviderClicked"
    );

    localStorage.removeItem("provider_api_key");
    localStorage.removeItem("schedulers_customer_config");
    if (!isRecommended && !exploreProviderClicked) {
      localStorage.setItem(
        "provider_info",
        JSON.stringify({
          name: formatNameToTitleCase(data?.firstName, data?.lastName),
        })
      );
      localStorage.setItem(
        "schedulers_customer_config",
        JSON.stringify({
          name: formatNameToTitleCase(data?.firstName, data?.lastName),
          jobTitle: formatNameToTitleCase(formatUserType(data?.userType)),
          lastName: formatNameToTitleCase(data?.lastName),
          firstName: formatNameToTitleCase(data?.firstName),
          medicalClinic: formatNameToTitleCase(data?.clinic[0]?.name),
          npiId: data?.npiId || null,
        })
      );
    }
  };

  const getProvider = async (id) => {
    setProviderDetail({});
    setLoader(true);
    const { data } = await axios.get("/v1/public/provider/" + id + "/detail");
    if (isEmpty(data)) navigate("/404");
    else if (data && data.hasOwnProperty("ratings")) data.rating = data.ratings;
    else if (data && !data.hasOwnProperty("rating")) data.rating = 0;
    if (data.planType !== "premium") {
      settabKey("home");
      setMoreMenu("home");
    } else {
      if (
        data?.userType === "clinic" &&
        data.profile_claimed_status !== undefined &&
        data.profile_claimed_status !== "approved"
      ) {
        settabKey("contact");
      } else {
        if (location?.state?.type === "exercise") {
          settabKey("exercises");
        } else {
          settabKey("home");
        }
      }
    }
    setCondition({
      name:
        data?.userType === "hospital" ||
        data?.userType === "clinic" ||
        data?.userType === "gym" ||
        data?.userType === "rehabilitation_center"
          ? data?.firstName
          : formatNameToTitleCase(data?.firstName, data?.lastName),
      usertype: data?.userType
        ? data?.userType !== "neuro_surgeon"
          ? "" + data?.userType?.split("_").join(" ") + ""
          : "" + data?.userType?.split("_").join("") + ""
        : "",
      address:
        data.userType === "orthopedic_surgeon" ||
        data.userType === "neuro_surgeon" ||
        data.userType === "primary_care" ||
        data.userType === "nurse_practitioner" ||
        data?.userType === "pain_management_specialist"
          ? data?.clinic[0]?.city
          : data.userType === "wellness_provider" ||
            data.userType === "massage_therapist"
          ? data?.business_info?.city
          : data.userType === "physical_therapist" ||
            data.userType === "chiropractor"
          ? data?.rehab_info?.city
          : data?.city,
    });
    setLoader(false);
    setSchedulerConfig(data);
    setProviderDetail(data);
  };
  const getMembershipDetails = async () => {
    const { data } = await axios.get(
      "/v1/public/membership/plan/" + providerDetail?.membershipId
    );
    setMembershipDetail(data);
  };

  const handleCloseBook = () => setShowBook(false);

  useEffect(() => {
    sessionStorage.setItem("provider", params.id);
    localStorage.setItem("provider_enhanced", false);
    getProvider(params.id);
    // eslint-disable-next-line
  }, [params]);

  useEffect(() => {
    document.getElementById("root").scrollTo(0, 0);
    if (providerDetail?.name) {
      mixpanel.track("User", {
        type: "Page View",
        name: `${getProviderName(providerDetail)} Profile`,
      });
    }

    if (providerDetail?.membershipId) getMembershipDetails();
    // eslint-disable-next-line
  }, [providerDetail]);

  const renderContent = (type) => {
    switch (type) {
      case "home":
        return <HomeTab providerDetail={providerDetail} />;
      case "reviews":
        return <ProfileTab providerDetail={providerDetail} />;
      case "contact":
        return <ContactTab providerDetail={providerDetail} />;
      case "classes":
        return <ClassesTab providerDetail={providerDetail} />;
      default:
        return <></>;
    }
  };

  const handleBookAppointmentClick = () => {
    localStorage.setItem(
      "provider_info",
      JSON.stringify({
        name: schedulerConfigData.name,
      })
    );
    localStorage.setItem(
      "schedulers_customer_config",
      JSON.stringify(schedulerConfigData)
    );
    navigate("/orthocheck");
  };

  return (
    <Layout>
      <div className="mt-3" ref={ref}>
        <HelmetTag
          title={`${condition.name} | ${capitalize(condition.usertype)} in ${
            condition.address
          } `}
          content={`${condition.name} is an expertly trained ${condition.usertype} dedicated to providing exceptional care to individuals throughout ${condition.address}.`}
          canonical={`https://myorthopedicproblem.com/providers/${params.id}`}
          JSONLD={`{
            "@context": "http://schema.org",
            "@type": "Person",
            "name": "${condition.name}",
            "url": "https://myorthopedicproblem.com/providers/${params.id}"
        }
        `}
        />
        {loader ? (
          <div className="d-flex justify-content-center">
            <LoadingScreen color="primary" />
          </div>
        ) : (
          <>
            <section>
              <div className="container px-sm-5">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="provider-bg">
                      {providerDetail.banner || providerDetail?._id ? (
                        <Image
                          src={providerDetail.banner}
                          alt="Find a Provider Banner"
                          className={`w-100 banner-image ${
                            providerDetail.banner ? "" : "p-5"
                          } rounded shadow-sm bg-muted-25 p-3`}
                        />
                      ) : (
                        <> </>
                      )}
                    </div>
                    <div className="d-flex justify-content-start">
                      <div className="provider-pic w-100">
                        <div className="img-provider ms-md-0 ms-3">
                          {providerDetail?.photo?.includes(
                            "https://dev-mop.s3.us-east-2.amazonaws.com//"
                          ) || !providerDetail?.photo?.length ? (
                            providerDetail?.userId?.length && (
                              <Image
                                src={providerDetail?.photo}
                                type="provider"
                                gender={providerDetail?.gender?.toUpperCase()}
                                alt="Find a Provider"
                              />
                            )
                          ) : (
                            <Image
                              src={providerDetail?.photo}
                              type="provider"
                              gender={providerDetail?.gender?.toUpperCase()}
                              alt="Find a Provider"
                            />
                          )}
                        </div>
                        <div
                          className="profile-provider mt-2 mb-0"
                          style={{ width: "fit-content" }}
                        >
                          <div className="content ms-md-1 ms-2">
                            <div className="heading fw-bold user-name d-md-flex">
                              {providerDetail?.userType === "hospital" ||
                              providerDetail?.userType === "clinic" ||
                              providerDetail?.userType === "gym" ||
                              providerDetail?.userType ===
                                "rehabilitation_center"
                                ? providerDetail?.firstName
                                : getProviderName(providerDetail)}
                              {providerDetail?.mopRecommended && (
                                <i className="fa fa-check-circle text-primary small ms-lg-2 ms-1 mt-2" />
                              )}
                              <div className="heading fw-bold d-flex user-name p-0 ps-md-2">
                                {providerDetail?.isEnhancedProvider !== true &&
                                  brand.key !== "mdp" && (
                                    <a
                                      href={`${brand.webUrl}/for-providers`}
                                      className="text-decoration-none"
                                    >
                                      Claim Your Profile?
                                    </a>
                                  )}
                              </div>
                            </div>
                            <p className="text-muted text-capitalize mb-0">
                              {providerDetail?.userType
                                ? providerDetail?.userType !== "neuro_surgeon"
                                  ? "" +
                                    providerDetail?.userType
                                      ?.split("_")
                                      .join(" ") +
                                    ""
                                  : "" +
                                    providerDetail?.userType
                                      ?.split("_")
                                      .join("") +
                                    ""
                                : ""}
                            </p>
                            <div className="d-md-flex d-none align-items-center btn_provider">
                              <button
                                className="btn my-3 btn-primary btn-sm me-4 fs-5 fw-normal"
                                onClick={handleBookAppointmentClick}
                              >
                                {`Try ${brand.checkerName} Free`}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex d-md-none align-items-center btn_provider justify-content-center">
                          <button
                            className="btn my-3 btn-primary btn-sm me-2 fs-5 fw-normal"
                            onClick={handleBookAppointmentClick}
                          >
                            {`Try ${brand.checkerName} Free`}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {(providerDetail.planType === "premium" &&
              JSON.stringify(membershipDetail) === "{}") ||
            membershipDetail?.askAnExpertSocial ? (
              <>
                {providerDetail.askAnExpert &&
                  providerDetail?.userType !== "primary_care" &&
                  providerDetail?.userType !== "clinic" &&
                  providerDetail?.userType !== "nurse_practitioner" &&
                  providerDetail?.userType !== "neuro_surgeon" &&
                  providerDetail?.userType !== "athletic_trainers" &&
                  providerDetail?.userType !== "orthopedic_surgeon" && (
                    <section className="my-3">
                      <div className="container px-md-5">
                        <div className="row">
                          <div className="col-12">
                            <div className="d-sm-flex bg-white rounded border justify-content-center p-3">
                              <div className="d-flex">
                                <h5 className="mb-0 align-self-center">
                                  {` Want to ask ${
                                    providerDetail?.userType === "hospital" ||
                                    providerDetail?.userType === "clinic" ||
                                    providerDetail?.userType === "gym" ||
                                    providerDetail?.userType ===
                                      "rehabilitation_center"
                                      ? providerDetail?.firstName
                                      : `${getName(providerDetail)}`
                                  } a question? Skip the wait and click the button`}
                                </h5>
                              </div>
                              <button className="btn btn-outline-primary btn-primary text-white fw-semibold mt-3 mt-sm-0 ms-md-2">
                                Ask An Expert
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
              </>
            ) : (
              <></>
            )}

            <div className="container px-4">
              <hr
                className={`mx-md-4 ${
                  providerDetail.planType === "premium" ? "my-0" : "mt-5"
                }`}
              />
            </div>
            <section>
              <div className="container px-md-5">
                <div className="row">
                  <div className="col-12 bg-white pt-2 provider-tabs d-md-block d-none">
                    {JSON.stringify(membershipDetail) === "{}" ||
                    membershipDetail?.blogs ? (
                      <Tabs
                        className="mb-3"
                        variant="pills"
                        fill
                        defaultActiveKey={tabKey}
                        onSelect={(key) => {
                          window.fbq(
                            "track",
                            `${
                              providerDetail.firstName
                            }'s ${key.toUpperCase()} Tab is opened.`
                          );
                          document.getElementById("root").scrollTo(0, 0);
                          settabKey(key);
                        }}
                      >
                        <Tab eventKey="home" title="About">
                          <HomeTab providerDetail={providerDetail} />
                        </Tab>
                        <Tab eventKey="contact" title="Contact & Location">
                          <ContactTab providerDetail={providerDetail} />
                        </Tab>
                        {providerDetail.planType === "premium" &&
                          (providerDetail?.userType === "wellness_provider" ||
                            providerDetail?.userType === "personal_trainer" ||
                            providerDetail?.userType === "gym") && (
                            <Tab eventKey="classes" title="Classes">
                              <ClassesTab providerDetail={providerDetail} />
                            </Tab>
                          )}
                      </Tabs>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col-12 bg-white pt-2 provider-tabs d-md-none d-block">
                    {JSON.stringify(membershipDetail) === "{}" ||
                    membershipDetail?.blogs ? (
                      providerDetail.planType === "premium" ? (
                        <div className="container-sticky">
                          <div className="w-100">
                            <Tabs
                              className="mb-3 me-5"
                              variant="pills"
                              fill
                              activeKey={tabKey}
                              onSelect={(key) => {
                                window.fbq(
                                  "track",
                                  `${
                                    providerDetail.firstName
                                  }'s ${key.toUpperCase()} Tab is opened.`
                                );
                                document.getElementById("root").scrollTo(0, 0);
                                settabKey(key);
                                setMoreMenu("");
                              }}
                            >
                              <Tab
                                eventKey="home"
                                title="About"
                                className={`${
                                  tabKey === "home" ? "active" : ""
                                }`}
                              />
                              {providerDetail.planType === "premium" && (
                                <Tab
                                  eventKey="blogs"
                                  title="Posts"
                                  className={`${
                                    tabKey === "blogs" ? "active" : ""
                                  }`}
                                />
                              )}
                              {providerDetail.planType === "premium" && (
                                <Tab
                                  eventKey="reviews"
                                  title="Reviews"
                                  className={`${
                                    tabKey === "reviews" ? "active" : ""
                                  }`}
                                ></Tab>
                              )}
                            </Tabs>
                          </div>
                          <div className="fw-bold text-muted p-2 more-button">
                            <Dropdown>
                              <Dropdown.Toggle
                                className="bg-white text-muted fw-bold border-white p-0 profile-more fs--18"
                                id="dropdown-basic"
                              >
                                More
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="px-2">
                                {providerDetail.planType === "premium" && (
                                  <Dropdown.Item
                                    onClick={() => {
                                      settabKey("");
                                      setMoreMenu("exercise");
                                      document
                                        .getElementById("root")
                                        .scrollTo(0, 0);
                                    }}
                                    className="bg-white text-muted border-white"
                                  >
                                    <div
                                      className={`fw-bold text-muted ${
                                        moreMenu === "exercise"
                                          ? "border-5-bottom"
                                          : ""
                                      }`}
                                    >
                                      Exercises
                                    </div>
                                  </Dropdown.Item>
                                )}

                                <Dropdown.Item
                                  onClick={() => {
                                    settabKey("");
                                    setMoreMenu("contact");
                                    document
                                      .getElementById("root")
                                      .scrollTo(0, 0);
                                  }}
                                  className="bg-white text-muted border-white"
                                >
                                  <div
                                    className={`fw-bold text-muted ${
                                      moreMenu === "contact"
                                        ? "border-5-bottom"
                                        : ""
                                    }`}
                                  >
                                    Contact & Location
                                  </div>
                                </Dropdown.Item>

                                {providerDetail.planType === "premium" &&
                                  (providerDetail?.userType ===
                                    "wellness_provider" ||
                                    providerDetail?.userType ===
                                      "personal_trainer" ||
                                    providerDetail?.userType === "gym") && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        settabKey("");
                                        setMoreMenu("classes");
                                        document
                                          .getElementById("root")
                                          .scrollTo(0, 0);
                                      }}
                                      className="bg-white text-muted border-white"
                                    >
                                      <div
                                        className={`fw-bold text-muted ${
                                          moreMenu === "classes"
                                            ? "border-5-bottom"
                                            : ""
                                        }`}
                                      >
                                        Classes
                                      </div>
                                    </Dropdown.Item>
                                  )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex position-relative">
                          <div className="w-100">
                            <Tabs
                              className="mb-3 me-5"
                              variant="pills"
                              fill
                              activeKey={tabKey}
                              onSelect={(key) => {
                                window.fbq(
                                  "track",
                                  `${
                                    providerDetail.firstName
                                  }'s ${key.toUpperCase()} Tab is opened.`
                                );
                                settabKey(key);
                                document.getElementById("root").scrollTo(0, 0);
                                setMoreMenu("");
                              }}
                            >
                              <Tab
                                eventKey="contact"
                                title="Contact & Location"
                              ></Tab>
                              <Tab eventKey="" title=""></Tab>
                              <Tab eventKey="" title=""></Tab>
                            </Tabs>
                          </div>
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                    {tabKey !== ""
                      ? renderContent(tabKey)
                      : renderContent(moreMenu)}
                  </div>
                </div>
              </div>
            </section>
            <Modal
              show={showBook}
              onHide={handleCloseBook}
              centered
              className="phoneModal"
            >
              <Modal.Body className="text-center bg-teal rounded border border-2 border-primary">
                <div className="mb-3 py-3 h5">
                  <p className="text-dark mb-0">
                    {bookAnAppointmentText}
                    {providerDetail?.phoneNumber
                      ? `${formatPhoneNumber(providerDetail?.phoneNumber)}`
                      : ""}
                  </p>
                </div>
                <Button className="btn btn-primary mx-2">
                  <a
                    className="text-decoration-none text-white"
                    href={`tel:${providerDetail?.phoneNumber}`}
                    onClick={handleCloseBook}
                  >
                    Call
                  </a>
                </Button>
                <Button className="btn btn-primary" onClick={handleCloseBook}>
                  OK
                </Button>
              </Modal.Body>
            </Modal>
            <Modal
              show={showBook}
              onHide={handleCloseBook}
              className="mobilePhoneModal"
              centered
            >
              <Modal.Body className="text-center bg-teal rounded border border-2 border-primary">
                <div className="mb-3 py-3 h5">
                  <p className="text-dark mb-0">
                    {bookAnAppointmentText}
                    {formatPhoneNumber(providerDetail?.phoneNumber)}
                  </p>
                </div>
                <Button className="btn btn-primary mx-2">
                  <a
                    className="text-decoration-none text-white"
                    onClick={handleCloseBook}
                    href={`tel:${providerDetail?.phoneNumber}`}
                  >
                    Call
                  </a>
                </Button>
                <Button className="btn btn-primary" onClick={handleCloseBook}>
                  OK
                </Button>
              </Modal.Body>
            </Modal>
          </>
        )}
      </div>
    </Layout>
  );
};
export default ProviderDetails;
